var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRightArrow(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 84 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2 8a2 2 0 000 4V8zm80 4a2 2 0 000-4v4zm-9.867 4.51a2 2 0 102.67 2.98l-2.67-2.98zm11.046-4.528a2 2 0 10-2.67-2.978l2.67 2.979zM74.802.511a2 2 0 00-2.67 2.978l2.67-2.978zm5.708 10.485a2 2 0 002.67-2.979l-2.67 2.98zM2 12h80V8H2v4zm72.802 7.49l8.377-7.507-2.67-2.98-8.376 7.508 2.67 2.978zm-2.67-16l8.378 7.506 2.67-2.979L74.801.511l-2.67 2.978z",
    fill: "#529ED0"
  })));
}
export default SvgRightArrow;